import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { RekbotsService } from '../../../../services/rekbots.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Organization } from '../../../../models/organization.model';
import { OrganizationsService } from '../../../../services/organizations.service';
import { MatSelectModule } from '@angular/material/select';
import { NotificationService } from '../../../../services/notification.service';

@Component({
  selector: 'app-rekbot-form',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule
  ],
  templateUrl: './rekbot-form.component.html',
  styleUrl: './rekbot-form.component.scss'
})
export class RekbotFormComponent implements OnInit {

  public organizations: Organization[] = [];

  @Input() rekbotId: number = 0;

  editForm: FormGroup;
  rekbot: any;

  constructor(
    private rekbotsService: RekbotsService,
    private organizationService: OrganizationsService,
    private notificationService: NotificationService,
  ) {
    this.editForm = new FormGroup({
      id: new FormControl(""),
      serial_no: new FormControl(''),
      ipv4: new FormControl(''),
      port: new FormControl(8080),
      gps_device_id: new FormControl(0),
      status: new FormControl(1),
      organization_id: new FormControl(0)
    });
  }


  fetchRekbot() {
    this.rekbotsService.fetchRekbot(this.rekbotId)
      .subscribe({
        next: (data: any) => {
          this.rekbotsService.setRekbot(data.rekbot);
          this.rekbot = data.rekbot;
          this.editForm.setValue({
            id: this.rekbot.id,
            serial_no: this.rekbot.serial_no,
            ipv4: this.rekbot.ipv4,
            port: this.rekbot.port,
            gps_device_id: this.rekbot.gps_device_id,
            status: 1,
            organization_id: this.rekbot.organization_id
          });
        },
        error: (error: any) => {
          console.error(error);
        }
      });
  }

  ngOnInit(): void {

    this.organizationService.fetchOrganizations()
      .subscribe({
        next: (data: any) => {
          this.organizations = data;
        },
        error: (error: any) => {
          console.error(error);
        }
      });

    console.log("init", this.rekbotId)

    if (this.rekbotId) {
      this.fetchRekbot();
    }
  }

  onSubmit() {
    console.log("submit")
    if (this.editForm.valid) {
      if (this.rekbotId) {
        this.updateRekbot(this.editForm.value);
      } else {
        this.createRekbot();
      }
    }
  }

  createRekbot() {
    this.rekbotsService.addRekbot(this.editForm.value)
      .subscribe({
        next: (data: any) => {
          console.log(data);
          this.notificationService.pushNotification(
            `Rekbot został dodany`, 'info', 5000);
        },
        error: (error: any) => {
          console.error(error);
          this.notificationService.pushNotification(
            `Błąd podczas tworzenia rekbota`, 'error', 5000);
        }
      });
  }

  updateRekbot(rekbot: any) {
    this.rekbotsService.updateRekbot(rekbot)
      .subscribe({
        next: (data: any) => {
          console.log(data);
          this.notificationService.pushNotification(
            `Rekbot został zapisany`, 'info', 20000);
        },
        error: (error: any) => {
          console.error(error);
        }
      });
  }

  getSaveText() {
    if (this.rekbotId) {
      return 'Zapisz';
    } else {
      return 'Dodaj';
    }
  }

}
